import { Link } from "react-router-dom";
import { ArrowRight, BedDouble } from "lucide-react";
import { HeroSlideshow } from "./HeroSlideshow";

export function LandingHeader() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 h-16 sm:h-20 flex items-center justify-between gap-2">
        <Link to="/" className="font-hero text-xl sm:text-3xl font-bold tracking-tight whitespace-nowrap" data-testid="logo">
          Stay<span className="text-blue-600">Care</span>
        </Link>
        <div className="flex items-center gap-1.5 sm:gap-3">
          <Link to="/tenant" data-testid="nav-tenant"
                className="text-[11px] sm:text-sm font-semibold bg-slate-900 text-white border border-slate-900 px-2.5 sm:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-slate-800 transition-colors inline-flex items-center gap-1 sm:gap-2 whitespace-nowrap">
            Tenant <span className="hidden sm:inline">portal</span>
          </Link>
          <Link to="/register" data-testid="nav-get-started"
                className="text-[11px] sm:text-sm font-semibold bg-blue-600 text-white px-2.5 sm:px-6 py-2 sm:py-2.5 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center gap-1 sm:gap-2 whitespace-nowrap">
            Get Started <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4" />
          </Link>
        </div>
      </div>
    </header>
  );
}

const HERO_BG = {
  backgroundImage:
    "radial-gradient(600px 600px at 85% 0%, rgba(191,219,254,0.55), transparent 70%), radial-gradient(500px 500px at 0% 60%, rgba(240,249,255,0.9), transparent 70%)",
};

export function HeroSection({ propertyCount }) {
  return (
    <section className="relative pt-28 sm:pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden" style={HERO_BG}>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-10 grid lg:grid-cols-2 gap-10 lg:gap-8 items-center">
        <div className="animate-fade-in-up">
          <h1 className="font-hero text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05]" data-testid="hero-heading">
            <span className="text-[#0b1220] text-[80%]">Where Comfort,</span>
            <br />
            <span className="text-blue-600">Feels Like Home.</span>
          </h1>
          <p className="mt-7 text-base sm:text-lg text-slate-500 max-w-lg leading-relaxed">
            Explore available PG rooms across {propertyCount || 6} prime locations. Real-time vacancy
            status, transparent monthly rent, and instant tenant application.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <a href="#rooms" data-testid="hero-cta-rooms"
               className="inline-flex items-center gap-3 bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-base hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/25">
              Explore Available Rooms <BedDouble className="h-5 w-5" />
            </a>
            <Link to="/register" data-testid="hero-cta-signup"
                  className="inline-flex items-center gap-3 bg-[#0b1220] text-white px-8 py-4 rounded-lg font-semibold text-base hover:bg-slate-800 transition-colors">
              Get Started <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </div>
        <div className="relative animate-fade-in-up" style={{ animationDelay: "150ms" }}>
          <HeroSlideshow />
        </div>
      </div>
    </section>
  );
}
